import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import ContractorsLayer from '../components/ContractorsLayer';

const ContractorsPage = () => {
  return (
    <MasterLayout pageTitle='Contractors'>
      <ContractorsLayer />
    </MasterLayout>
  );
};

export default ContractorsPage;
